<template>
  <div>
    <div
      v-if="$store.currentStatus === 1"
      class="ticket__body__status"
    >
      <div class="ticket__body__status__icon">
        <i :class="[$store.waitingTickets.length ? 'ri-coupon-3-line' : 'ri-cup-line']" />
      </div>
      <div
        v-if="$store.waitingTickets.length"
        class="ticket__body__status__title"
      >
        {{ 'd_ws_queue_tickets' | translate }} {{ $store.waitingTickets.length }}
        <span class="timer" v-if="$store.deviceStartData.unit_settings.automatic_call_of_ticket">
          {{ 'd_ws_ticket_autocall_timing' | translate }} {{ $store.autoCallTimer }}
        </span>
      </div>
      <div
        v-else
        class="ticket__body__status__title"
      >
        {{ 'd_ws_tab_queue_empty' | translate }}
      </div>
    </div>
    <div
      v-else-if="status"
      class="ticket__body__status"
    >
      <div class="ticket__body__status__icon">
        <i :class="status.icon" />
      </div>
      <div class="ticket__body__status__title" :title="(status.hasOwnProperty('default') && status.default) ? $options.filters.translate(status.title) : status.title">
        {{ (status.hasOwnProperty('default') && status.default) ? $options.filters.translate(status.title) : status.title }}
      </div>
      <div class="ticket__body__status__timer">
        <Timer
          :ticket-time="$store.currentStatusTimestamp"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Timer from '../controls/Timer';

export default {
  props: ['status'],
  components: {
    Timer
  }
}
</script>

<style lang="scss" scoped>
  .ticket {
    &__body {
      &__status {
        text-align: center;
        padding-top: 20px;
        color: var(--label-primary);
        &__icon {
          margin-bottom: 4px;
          i {
            font-size: 32px;
            vertical-align: middle;
          }
        }
        &__title {
          font-size: 22px;
          line-height: 27px;
          font-feature-settings: 'zero' on;
          margin-bottom: 4px;
          -webkit-line-clamp: 4;
          overflow: hidden;
          white-space: normal;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          span.timer {
            display: block;
            color: var(--accent-pink);
            font-weight: 300;
            line-height: 150%;
            font-size: 16px;
          }
        }
        &__timer {
          font-feature-settings: 'ss02' on;
          font-weight: 300;
          font-size: 16px;
          line-height: 150%;
          color: var(--label-secondary);
        }
      }
    }
  }
</style>
